import styled from '@emotion/styled'

export const Pending = styled.div`
  display: grid;
  grid-template-columns: 50px 30% auto 120px;
`

export const Title = styled.h4`
  
`
